export const photoCount = n => (n === 0 ? 'no photos' : `${n} ${n === 1 ? 'photo' : 'photos'}`);

// A fixed list, not the device's locale: the byline reads the same everywhere ("Sep", never "Sept").
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatDate(ms, now = Date.now()) {
  const d = new Date(ms);
  const day = `${d.getDate()} ${MONTHS[d.getMonth()]}`;
  return d.getFullYear() === new Date(now).getFullYear() ? day : `${day} ${d.getFullYear()}`;
}
